import { ContactProperty } from './ContactProperty';

export { ContactProperty };
